import React from 'react';

import { IonItem, IonList } from '@ionic/react';

import EmptyContent from 'components/EmptyContent';
import Typography from 'components/Typography';
import { AmountFormatter } from 'intl';
import { useDownloadInvoice } from 'scenes/FinancePage/FR/data/mutations/useDownloadInvoice';

import Status from './сomponents/Status';

interface IInvoices {
  data: any;
  total: any;
}
const Invoices = ({ data = [], total }: IInvoices) => {
  const [download] = useDownloadInvoice();

  return (
    <>
      <IonList>
        {!data?.length && <EmptyContent withBorder={false} />}
        {data.map((row: any) => {
          let title = `${row.type.name} / #${row.id}`;
          if (row.externalId) {
            title += `/ SAP #${row.externalId}`;
          }
          return (
            <IonItem
              key={row.id}
              button={true}
              detail={false}
              lines={'full'}
              className={'padding-top padding-bottom'}
              onClick={() =>
                download({ id: row.id, fileName: row.attachment.name })
              }
            >
              <div>
                <div>
                  <Typography variant={'overline'} color={'medium-shade'}>
                    {title}
                  </Typography>
                </div>
                <div>
                  <Typography variant={'subtitle1'} color={'primary'}>
                    {row.name}
                  </Typography>
                </div>
                <div>
                  <Typography>
                    GG Spend: <AmountFormatter value={row.spending} />
                  </Typography>
                </div>
                <div>
                  <Typography>
                    Invoice Amount: <AmountFormatter value={row.amount} />
                  </Typography>
                </div>
              </div>
              <Status slot={'end'} value={row?.status} />
            </IonItem>
          );
        })}
        <IonItem lines={'none'} className={'invoiceItem padding-top'}>
          <div>
            <div>
              <Typography variant={'overline'} color={'medium-shade'}>
                Total invoices amount
              </Typography>
            </div>
            <div>
              <h4>
                <AmountFormatter value={total} />
              </h4>
            </div>
          </div>
        </IonItem>
      </IonList>
    </>
  );
};
export default Invoices;
